import { getSpkCapitalOneInstantNotificationTbl } from '../../../graphql/queries';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

/**
 * Fetches a single instant notification record by its primary key ID.
 * Used to check the current status/isSubmitted state of a notification
 * before and during the receipt upload flow.
 * 
 * Returns the notification object with at minimum:
 *   { id, status, isSubmitted, isMatched, capitalOneCreditCardTransactionReceiptId }
 * Returns null if not found or on error.
 */
export const fetchInstantNotificationById = async (id) => {
  if (!id) {
    console.error('fetchInstantNotificationById: No ID provided');
    return null;
  }

  try {
    console.log('fetchInstantNotificationById: fetching notification for id:', id);

    const response = await client.graphql({
      query: getSpkCapitalOneInstantNotificationTbl,
      variables: { id },
    });

    console.log('fetchInstantNotificationById: response:', response);

    const notification = response?.data?.getSpkCapitalOneInstantNotificationTbl;

    if (!notification) {
      console.warn('fetchInstantNotificationById: No notification found for id:', id);
      return null;
    }

    console.log('fetchInstantNotificationById: found notification:', {
      id: notification.id,
      status: notification.status,
      isSubmitted: notification.isSubmitted,
      isMatched: notification.isMatched,
      hasLinkedReceipt: !!notification.capitalOneCreditCardTransactionReceiptId,
    });

    return notification;
  } catch (err) {
    console.error('fetchInstantNotificationById: error fetching notification:', err);
    return null;
  }
};

fetchInstantNotificationById.propTypes = {
  id: PropTypes.string.isRequired,
};